module.exports = __webpack_public_path__ + "img/play.2d699d9.png";